import ReactInputMask from "react-input-mask";
import PropTypes from "prop-types";
import handleTabIndex from "../Utils/HandleTabIndex";

const InputMask = props => {
  const keyPress = e => {
    if (!!props?.onKeyDown)
      props.onKeyDown(e);

    if (e.keyCode === 13)
      handleTabIndex(props.tabIndex, props.nextTab);
  };

  return <ReactInputMask maskChar={null} {...props} onKeyDown={keyPress} >
    {inputProps => <input className="ant-input"  {...inputProps} />}
  </ReactInputMask>;
};

InputMask.propTypes = {
  mask: PropTypes.string,
  maskChar: PropTypes.string,
  formatChars: PropTypes.object,
  alwaysShowMask: PropTypes.bool,
  inputRef: PropTypes.func,
};

export default InputMask;
